import React from 'react';
import { Select, SelectOption, Tooltip } from '../../../../components/ui';
import { USER_ROLES } from '../../../../constants/auth';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { arrayContainsArray } from '../../../../helpers/array';
import {
  useQueryPermissionByRole,
  useQueryPermissionByUser,
} from '../../../../query/user';

type Props = {
  userId: number,
  errorTxt?: string,
  role: number,
  onRoleChange: (role: number) => void,
};

export default function UserRoleSelector(props: Props) {
  const { errorTxt, role, onRoleChange, userId } = props;
  const {
    isFetching: adminLoading,
    data: adminPermissions,
  } = useQueryPermissionByRole('admin');
  const {
    isFetching: regularLoading,
    data: regularPermissions,
  } = useQueryPermissionByRole('regular');

  const {
    isFetching: userPermissionLoading,
    data: userPermissionData,
  } = useQueryPermissionByUser(userId);

  const currentUserPermissions = useSelector(
    state => state.auth.user.permissions,
  );

  return (
    <Select
      className="select-template__btn"
      disabled={adminLoading || regularLoading || userPermissionLoading}
      error={errorTxt}
      helperTxt={errorTxt}
      label="User Role"
      name="Role"
      optionFilterProp="children"
      placeholder="User Role"
      showSearch
      value={role}
      onChange={onRoleChange}
    >
      <SelectOption key="default" value={-1}>
        Select Role
      </SelectOption>
      {Object.keys(USER_ROLES).map(roleOption => {
        let isDisabled = roleOption === role;
        let helperText;
        if (
          ['admin', 'regular'].indexOf(roleOption) >= 0 &&
          roleOption !== role
        ) {
          const newUserPermissions =
            roleOption === 'admin'
              ? [...adminPermissions]
              : [...regularPermissions];
          // Differences if this options is chosen
          const differences = _.xor(userPermissionData, newUserPermissions);
          isDisabled = !arrayContainsArray(currentUserPermissions, differences);
          if (isDisabled) {
            helperText = `Cannot change role because you are trying to modify user permissions but you don't have this (these) permission(s) ${_.difference(
              differences,
              currentUserPermissions,
            ).join(', ')}`;
          }
        }
        return (
          <SelectOption
            disabled={isDisabled}
            key={roleOption}
            value={roleOption}
          >
            <Tooltip title={helperText}>{roleOption}</Tooltip>
          </SelectOption>
        );
      })}
    </Select>
  );
}
